import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DistancePipe } from './distance.pipe';
import { ElapsedPipe } from './elapsed.pipe';
import { ProfilePicComponent } from './profile-pic/profile-pic.component';
import { IonicModule, ModalController } from '@ionic/angular';
import { LongPressDirective } from './longpress.directive';
import { PolylineMapComponent } from './polyline-map/polyline-map.component';
import { GaugeComponent } from './gauge/gauge.component';
import { ModalComponent } from './modal/modal.component';
import { SafePipe } from './safe.pipe';
import { HrmComponent } from './hrm/hrm.component';
import { RecordTimerComponent } from './record-timer/record-timer.component';
import { GarminBoxComponent } from './garmin-box/garmin-box.component';
import { GarminCirclesComponent } from './garmin-circles/garmin-circles.component';
import { ImageFallbackDirective } from './image-fallback.directive';
import { RoundedPipe } from './rounded.pipe';
import { StravaGraphComponent } from './strava-graph/strava-graph.component';
import { WeatherBoxComponent } from './weather-box/weather-box.component';
import { CalendarComponent } from './calendar/calendar.component';
import { WatchFaceComponent } from './watch-face/watch-face.component';
import { GarminRecordComponent } from './garmin-record/garmin-record.component';
import { ColorPickerComponent } from './color-picker/color-picker.component';
import { StravaTableComponent } from './strava-table/strava-table.component';
import { SegmentComponent } from './segment/segment.component';
import { StravaItemComponent } from './strava-item/strava-item.component';
import { Hrm2Component } from './hrm2/hrm2.component';
import { ChartComponent } from './chart/chart.component';
import { ZonesComponent } from './zones/zones.component';
import { StravaCardComponent } from './strava-card/strava-card.component';
import { StravaStatsComponent } from './strava-stats/strava-stats.component';
import { StravaRecordComponent } from './strava-record/strava-record.component';
import { StravaStickerComponent } from './strava-sticker/strava-sticker.component';

@NgModule({
  declarations: [
    CalendarComponent,
    ChartComponent,
    ColorPickerComponent,
    DistancePipe,
    ElapsedPipe,
    GarminBoxComponent,
    GarminCirclesComponent,
    GarminRecordComponent,
    GaugeComponent,
    Hrm2Component,
    HrmComponent,
    ImageFallbackDirective,
    LongPressDirective,
    ModalComponent,
    PolylineMapComponent,
    ProfilePicComponent,
    RecordTimerComponent,
    RoundedPipe,
    SafePipe,
    SegmentComponent,
    StravaCardComponent,
    StravaGraphComponent,
    StravaItemComponent,
    StravaRecordComponent,
    StravaStatsComponent,
    StravaStickerComponent,
    StravaTableComponent,
    WatchFaceComponent,
    WeatherBoxComponent,
    ZonesComponent,
  ],
  imports: [CommonModule, IonicModule],
  exports: [
    CalendarComponent,
    ChartComponent,
    ColorPickerComponent,
    DistancePipe,
    ElapsedPipe,
    GarminBoxComponent,
    GarminCirclesComponent,
    GarminRecordComponent,
    GaugeComponent,
    Hrm2Component,
    HrmComponent,
    ImageFallbackDirective,
    LongPressDirective,
    ModalComponent,
    PolylineMapComponent,
    ProfilePicComponent,
    RecordTimerComponent,
    RoundedPipe,
    SafePipe,
    SegmentComponent,
    StravaCardComponent,
    StravaGraphComponent,
    StravaItemComponent,
    StravaRecordComponent,
    StravaStatsComponent,
    StravaStickerComponent,
    StravaTableComponent,
    WatchFaceComponent,
    WeatherBoxComponent,
    ZonesComponent,
  ],
})
export class SharedModule {}
